import {
    InitialQueryState,
    QueryManagerOptions,
    SkipOrArgs,
} from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import {
    useCollectionAssets,
    UseCollectionAssetsArgs,
} from './useCollectionAssets';
import { useSelectedCollectionId } from './useSelectedCollectionSelectors';

export type UseSelectedCollectionAssetsArgs = Omit<
    UseCollectionAssetsArgs,
    'collectionId'
>;

export const useSelectedCollectionAssets = (
    initialArgs: InitialQueryState = {},
    args?: SkipOrArgs<UseSelectedCollectionAssetsArgs>,
    options?: QueryManagerOptions,
) => {
    const collectionId = useSelectedCollectionId();
    const queryArgs: SkipOrArgs<UseCollectionAssetsArgs> = useMemo(() => {
        if (args === skipToken || !collectionId) return skipToken;
        return { ...args, collectionId };
    }, [args, collectionId]);

    return useCollectionAssets(initialArgs, queryArgs, options);
};
